import React from 'react';
import EditableText from 'components/utils/EditableText';

type EditableSessionNameProps = {
  sessionId: string;
  sessionName: string;
  setSessionName: (name: string) => void;
  disabled?: boolean;
  onSessionNameUpdate?: (sessionId: string, newName: string) => Promise<void>;
};

const EditableSessionName: React.FC<EditableSessionNameProps> = ({
  sessionId,
  sessionName,
  setSessionName,
  disabled = false,
  onSessionNameUpdate
}) => {
  const handleSessionNameChange = async (newName: string) => {
    setSessionName(newName);
    if (onSessionNameUpdate) {
      await onSessionNameUpdate(sessionId, newName);
    }
  };

  return (
    <EditableText 
      value={sessionName}
      fallbackValue={sessionId}
      onChange={handleSessionNameChange}
      disabled={disabled}
      className="py-3 px-4 font-medium text-sm sm:text-base md:text-lg"
      placeholder="Session Name"
      showEditIcon={true}
    />
  );
};

export default EditableSessionName;
